import { ActionButtonProps, Box, BoxProps, ColorOptions, Form } from '@jfs/ui-new'
import { ButtonNew } from '../../components/AdminButton'
import { RefCalback } from '@jfs/ui-new/src/comps/Form/types'
import { FC, useEffect, useRef } from 'react'
import { useLazyApiData, useStores } from '../../data/store'
import { formData } from './formData'

interface AddCardProps {
  hide?: boolean
  initialData?: any
  id?: string
  onUpdate?: () => void
  onClose?: () => void
  selectedArr?: any
}
const AddBankCode: FC<AddCardProps> = ({
  hide = true,
  initialData = {},
  id,
  onUpdate,
  onClose,
  selectedArr,
}: AddCardProps) => {
  const formref = useRef<RefCalback>(null)
  const { addCode, message, updateCode, getCodeNames } = useStores((store) => ({
    addCode: store.bankingCode.addBankingCode,
    updateCode: store.bankingCode.updateBankCode,
    accessConfig: store.user.accessConfig,
    user: store.user,
    message: store.message.getFormMessage(),
    getCodeNames: store.user.fetchCodeNames,
  }))

  const [lazyAddCode, lazyAddCodeHandler] = useLazyApiData(addCode)
  const [lazyUpdateCode, lazyUpdateCodeHandler] = useLazyApiData(updateCode)
  const [lazyGetCodeNames, lazyGetCodeNamesHandler] = useLazyApiData(getCodeNames)

  useEffect(() => {
    if (lazyUpdateCodeHandler.state === 'fulfilled') {
      console.log('updated')
      onUpdate && onUpdate()
    }
  }, [lazyUpdateCodeHandler.state, onUpdate])

  useEffect(() => {
    if (lazyAddCodeHandler.state === 'fulfilled') {
      console.log('added')
      onUpdate && onUpdate()
    }
    if (lazyAddCodeHandler.state === 'rejected') {
      console.log('error add')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lazyAddCodeHandler])

  useEffect(() => {
    lazyGetCodeNames('BANK_CODE_TYPE')
  }, [lazyGetCodeNames])

  if (!hide) {
    return null
  }

  const addBankCode = (values: any) => {
    values.type =
      Object.keys(lazyGetCodeNamesHandler?.data).find((key) => lazyGetCodeNamesHandler?.data[key] === values.type) ??
      values.type
    lazyAddCode(values)
  }

  const updateBankCode = (values: any) => {
    values.type =
      Object.keys(lazyGetCodeNamesHandler?.data).find((key) => lazyGetCodeNamesHandler?.data[key] === values.type) ??
      values.type
    lazyUpdateCode(values)
  }

  const handleActions = ({ values, title, defaultActionButtonOnSubmit }: ActionButtonProps) => {
    const handleOnPress = () => {
      defaultActionButtonOnSubmit()
    }

    return (
      <Box pv={16} justify={'center'} align={'center'}>
        <ButtonNew
          title={title}
          onPress={handleOnPress}
          height={40}
          color={'#214796'}
          width={300}
          textType={'bodyMedium14'}
          isLoading={lazyAddCodeHandler.state === 'pending'}
        />
      </Box>
    )
  }

  return (
    <Box onPress={() => {}} {...styles.container} minHeight={selectedArr?.length > 0 ? 220 : 400}>
      <Form
        formData={formData(addBankCode, updateBankCode, message, id, lazyGetCodeNamesHandler?.data)}
        actionButtons={handleActions}
        ref={formref}
        initialValues={initialData}
        container={FormBox}
      />
    </Box>
  )
}

const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}
const styles = {
  container: {
    underlayColor: 'WHITE',
    overflow: 'auto',
    bg: 'WHITE',
    padding: 'MEDIUM',
    backgroundColor: 'WHITE',
    minWidth: 300,
    borderWidth: 1,
    borderTopWidth: 0,
    borderColor: '#e3e6f0' as ColorOptions,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4,
    ...shadow,
  } as BoxProps,
}

const FormBox = ({ children }: any) => {
  return (
    <Box flexDirection={'column'} flex={1}>
      {children}
    </Box>
  )
}

export { AddBankCode }
